import { render, staticRenderFns } from "./TaxationType.vue?vue&type=template&id=78852913&"
import script from "./TaxationType.vue?vue&type=script&lang=js&"
export * from "./TaxationType.vue?vue&type=script&lang=js&"
import style0 from "./TaxationType.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports